'use strict';

const internals = {};


module.exports = function (...args) {

    try {
        return JSON.stringify.apply(null, args);
    }
    catch (err) {
        return '[Cannot display object: ' + err.message + ']';
    }
};



// WEBPACK FOOTER //
// ./node_modules/@hapi/hoek/lib/stringify.js